import './App.css'
import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import Sidenavbar from './Component/Sidenavbar'
import AddStudent from './Component/AddStudent'
// import TeacherStudent from './Component/TeacherStudent'
import AddCourse from './Component/AddCourse'
import AddClass from './Component/AddClass'
import ClassList from './Component/ClassList'
import TakeAttendance from './Component/TakeAttendance'
import Practicenavbar from './Component/Practicenavbar'
import LoginSignup from './Component/LoginSignup'
import StudentProfile from './Component/StudentProfile'
import TakeFees from './Component/TakeFees'
import CourseFees from './Component/CourseFees'
import IDcard from './Component/IDcard'
import StudentPromotion from './Component/StudentPromotion'
import EnquiryForm from './Component/EnquiryForm'
import ExamMarksheet from './Component/ExamMarksheet'
import TeacherList from './Component/TeacherList'
import FeeStructure from './Component/FeeStructure'
import ApplyFees from './Component/ApplyFees'
import Dashboard from './Component/Dashboard'
import { Toaster } from 'react-hot-toast'
import AddInstitute from './Component/AddInstitute'
import AddSubject from './Component/AddSubject'
import ExamSheet from './Component/ExamSheet'
import AddExamResult from './Component/AddExamResult'
import AssignClass from './Component/AssignClass'
import ManageStudentFees from './Component/ManageStudentFees'
import Certificate from './Component/Certificate'
import FeeRecipt from './Component/FeeRecipt'
import ViewAttendance from './Component/ViewAttendance'
import { useAuth } from './Component/AuthContext'
import TeacherProfile from './Component/TeacherProfile'
import TeacherIdcard from './Component/TeacherIdCard'
import FeeCollection from './Component/FeeCollection'
import Marketer from './Component/Marketer'
import EnrolledCourses from './Component/EnrolledCourses'
import Setting from './Component/Settings'
import UpdateStudentProfile from './Component/UpdateStudentProfile'
import DischargedStudent from './Component/DischargedStudent'
import UpdateStudentEnquiry from './Component/UpdateStudentEnquiry.js'
import StudentFees from './Component/StudentFees.js'
// import ForgotPassword from './Component/ForgotPassword.js'
import ChangePassword from './Component/ChangePassword.js'
import VivekanandCertificate from './Component/VivekanandCertificate.js'
import DischargedStudentFees from './Component/DischargedStudentFees.js'
import StudentTC from './Component/StudentTC.js'
import ParentStudentProfile from './Component/ParentStudentProfile.js'
import RaiseQuery from './Component/RaiseQuery.js'
import ParentStudentList from './Component/ParentStudentList.js'
import ParentStudentFees from './Component/ParentStudentFees.js'
import ParentViewAttendance from './Component/ParrentViewAttendance.js'
import ParentRegistration from './Component/ParentRegisteration.js'
import GuardianTable from './Component/AddGuardian.js'
import TeacherStudent from './Component/TeacherStudent.js'
import AddUser from './Component/AddUser.js'
import AssignUserRole from './Component/UserRole.js'
import DischargedStudentsProfile from './Component/DischargedStdProfile.js'
import DischargedStdAttendance from './Component/DischargedStdAttendance.js'

function App() {
  const location = useLocation()
  const isAuthPage = location.pathname === '/LoginSignup'
  const isParentRegPage = location.pathname === '/Parent/Registration'

  const { user } = useAuth()
  if (!user && !isAuthPage && !isParentRegPage) {
    return <Navigate to="/LoginSignup" replace />
  }
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            // zIndex: 9999,
            borderRadius: '8px',
            color: '#fff',
            padding: '10px',
            fontSize: '16px',
          },
          success: {
            style: { background: '#4caf50', color: '#fff' },
          },
          error: {
            style: { background: '#d32f2f', color: '#fff' },
          },
        }}
      />

      <div className="App" style={{ display: 'flex' }}>
        {!isAuthPage && user && <Sidenavbar />}
        <div style={{ flex: 1, padding: '12px' }}>
          <Routes>
            <Route path="/" element={<Navigate to="/LoginSignup" />} />
            <Route path="/LoginSignup" element={<LoginSignup />} />
            {/* <Route path="/Dashboard" element={<Navigate to="/LoginSignup" />} /> */}

            <Route path="/AddStudent" element={<AddStudent />} />
            <Route path="/TeacherStudent" element={<TeacherStudent/>} />
            {/* <Route path="/StudentList" element={<StudentList />} /> */}
            <Route path="/AddCourse" element={<AddCourse />} />
            <Route path="/AddClass" element={<AddClass />} />
            <Route path="/ClassList" element={<ClassList />} />
            <Route
              path="/TakeAttendance/:student_id?/:course_id?/:class_id?"
              element={<TakeAttendance />}
            />
            <Route
              path="/ViewAttendance/:student_id/:course_id/:class_id"
              element={<ViewAttendance />}
            />
            <Route path="/ViewAttendance" element={<ViewAttendance />} />
            <Route path="/Practicenavbar" element={<Practicenavbar />} />
            <Route path="/StudentProfile/:id" element={<StudentProfile />} />
            <Route path="/DischargedStudentsProfile/:id" element={<DischargedStudentsProfile />} />
            <Route path="/EnrolledCourses/:id" element={<EnrolledCourses />} />
            <Route
              path="/TakeFees/:student_id?/:course_id?"
              element={<TakeFees />}
            />
            <Route path="/EnquiryForm" element={<EnquiryForm />} />
            <Route path="/CourseFees" element={<CourseFees />} />
            <Route path="/IDcard/:id" element={<IDcard />} />
            <Route path="/StudentPromotion" element={<StudentPromotion />} />
            <Route
              path="/ExamMarksheet/:student_id?/:course_id?/:class_id?"
              element={<ExamMarksheet />}
            />
            <Route path="/TeacherList" element={<TeacherList />} />
            <Route path="/AddGuardian/:student_id?/:course_id?/:class_id?" element={<GuardianTable />} />
            <Route path="/FeeStructure" element={<FeeStructure />} />
            <Route
              path="/ApplyFees/:course_id?/:student_id?"
              element={<ApplyFees />}
            />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/AddInstitute" element={<AddInstitute />} />
            <Route path="/AddSubject" element={<AddSubject />} />
            <Route path="/ExamSheet" element={<ExamSheet />} />
            <Route path="/AddUser" element={<AddUser />} />
            <Route path="/Assign/UserRole/:id" element={<AssignUserRole />} />
            <Route
              path="/AddExamResult/:student_id?/:course_id?/:class_id?"
              element={<AddExamResult />}
            />
            <Route path="/AssignClass" element={<AssignClass />} />
            <Route
              path="/ManageStudentFees/:student_id?/:course_id?/:class_id?"
              element={<ManageStudentFees />}
            />
            <Route path="/StudentFees/:student_id?" element={<StudentFees />} />
            <Route path="/Certificate" element={<Certificate />} />
            <Route path="/Transfer/Certificate" element={<StudentTC />} />            
            <Route path="/owner-viv-ins-of-clg" element={<VivekanandCertificate />} />
            <Route
              path="/FeeRecipt/:studentId/:feeIds"
              element={<FeeRecipt />}
            />
            <Route path="/TeacherProfile/:id?" element={<TeacherProfile />} />
            <Route path="/TeacherIdCard/:id?" element={<TeacherIdcard />} />
            <Route path="ChangePassword" element={<ChangePassword />} />
            <Route path="/FeeCollection" element={<FeeCollection />} />
            <Route path="/Marketer" element={<Marketer />} />
            <Route path="Settings" element={<Setting />} />
            <Route
              path="/UpdateStudentProfile/:student_id"
              element={<UpdateStudentProfile />}
            />
            <Route
              path="/UpdateStudentEnquiry/:student_id"
              element={<UpdateStudentEnquiry />}
            />
            <Route path="/DischargedStudent" element={<DischargedStudent />} />
            <Route path="/DischargedStudentFees/:student_id?" element={<DischargedStudentFees />} />
            <Route path='/DischargedStudent/Attendance/:student_id/:course_id/:class_id' element={<DischargedStdAttendance/>}/>
            {/* Parent's routes */}
            <Route path="/Student/List" element={<ParentStudentList />} />
            <Route path="/Student/Profile/:id?" element={<ParentStudentProfile />} />
            <Route path="/Student/Fees/:student_id?/:course_id?/:class_id?" element={<ParentStudentFees />} />
            <Route path="/Student/Attendance/:student_id/:course_id/:class_id?" element={<ParentViewAttendance />} />
            <Route path="/Parent/Registration" element={<ParentRegistration />} />
            <Route path="/Raise-Query" element={<RaiseQuery />} />

            </Routes>
        </div>
      </div>
    </>
  )
}

export default App
